import { z } from 'zod';
export const OrganizationScopeSchema = z
    .union([z.literal('allAuthorized'), z.uuid(), z.array(z.uuid()).min(1)])
    .transform((value) => value === 'allAuthorized'
    ? value
    : [...new Set((Array.isArray(value) ? value : [value]).map((id) => id.toLowerCase()))].sort())
    .describe('Explicit organization selection: one or more UUIDs, or allAuthorized. Consumers must authorize selected IDs and resolve allAuthorized against current access.');
//# sourceMappingURL=organizationScope.js.map